<template>
    <div class="item-service">
        <ul>
            <li v-for="(item, index) in list" :key="index">
                <div :class="`has-icon add-icon ${isTrasferimento? 'add-transfer': 'add-task'} d-flex justify-content-between`">
                    <div>
                        <p>{{item.detail.name}}</p>
                        <small class="mr-1" v-if="!item.isTrasferimento && isSameDate(group.dateSelected, day)" v-for="(group, index) in item.groups" :key="index" :value="group">Camera {{group.id}}</small>
                    </div>
                    <div class="tools">
                        <button class="btn info" @click="onClickInfo(item)">
                            <div></div>
                        </button>
                        <button v-if="isDeletable(item)" class="btn delete" @click="onClickDelete(day, item)">
                            <div></div>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {isSameDate} from '../../../../utils/helper'

export default {
  name: 'ItemService',
  props: {
    isTrasferimento: {
      type: Boolean,
      default: false
    },
    day: {
      type: Date,
      default: new Date()
    }
  },
  data () {
    return {
      value: {
        groups: []
      }
    }
  },
  computed: {
    list () {
      return this.isTrasferimento ? this.$store.getters.getTrasferimentiSelectedByDay(this.day) : this.$store.getters.getServiziSelectedByDay(this.day)
    }
  },
  methods: {
    ...mapGetters(['getItinerario', 'getServiziFilter', 'getTrasferimentiFilter']),
    ...mapActions(['removeSelectedServizio', 'addReplaceServizio', 'modifyServiziFilter', 'modifyTrasferimentoFilter']),
    isDeletable (item) {
      return !item.isObbligatorio && !item.isTrasferimentoFisso
    },
    isSameDate,
    onClickDelete (day, item) {
      if (item.isTrasferimento) {
        const dayAndata = this.getItinerario().days[0].day
        const isAndata = isSameDate(day, dayAndata)
        this.removeSelectedServizio({day, servizio: {...item, isAndata}})
      } else {
        this.removeSelectedServizio({day, servizio: item})
      }
      this.$emit('delete', item)
    },
    onClickInfo (item) {
      this.$emit('detail', item)
    },
    onChangeGroup (groups) {
      this.groupsSelected = groups
      const payload = {...this.value, groups: [...this.groupsSelected]}
      this.addReplaceServizio(payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemService.vue